import React, { useState, useEffect } from "react";
import { CaretRightOutlined, RightOutlined } from "@ant-design/icons";
import {
  Collapse,
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  notification,
  Spin,
  Modal,
  Card,
  Avatar,
  Typography,
  Space
} from "antd";
import TimeSlotEnrollment from "./TimeSlotEnrollment";
import ProgrammeService from "../../api/programme.service";
import timeSlotService from "../../api/time.slot.service";
import commonUtility from "../../utility/Utils";
import StudentCardInfo from "../common/StudentCardInfo";
import {
  DATE_FORMAT_DMY_SLASH,
  HIGH_PERFORMANCE_TAG,
  SUCCESS_STATUS,
} from "../../utility/Constants";
import moment from "moment";
const { Text, Link } = Typography;

const { Panel } = Collapse;
const { Option } = Select;
const { confirm } = Modal;

const defaultFormValues = {
  mode: "ADD",
  enrollment_id: 0,
  old_enrollment_id: 0,
  member_id: 0,
  programme_id: 0,
  voucher_id: 0,
  date_of_join: null,
  enrollment_start_date: null,
  enrollment_end_date: null,
  last_paid_month: "",
  programme_group_id: 0,
  member_status: "Y",
  day_slot: [],
};

let styles = {
    studentInfoCard: {
        border:'0px'
    },
    studentPersonalInfo : {
        textAlign:'left',
        backgroundColor:'rgb(204, 247, 138)',
        padding:'10px 20px',
        borderTopLeftRadius:'10px', 
        borderBottomLeftRadius:'10px',
        borderRight:'3px solid #fff'
    },
 
  }


const ProgramTransfer = () => {
  const [form] = Form.useForm();
  const [fromProgramme, setFromProgramme] = useState(null);
  const [memberList, setMemberList] = useState([]);
  const [timeSlotList, setTimeSlotList] = useState([]);
  const [programmeGroupID, setProgrammeGroupID] = useState(0);
  const [enrollmentID, setEnrollmentID] = useState(0);
  const [programmeID, setProgrammeID] = useState([]);
  const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [programmeGroupList, setProgrammeGroupList] = useState([]);
  const [lastPaidData, setLastPaidData] = useState();
  const [toProgramme, setToProgramme] = useState(null);

  const [memberDisplayInfo, setMemberDisplayInfo] = useState({
    memberName: "",
    memberPrimaryMobile: "",
    memberFatherName: "",
    memberDOB: "",
    profilePic: "",
  });

  const [memberDisplayOtherInfo, setMemberDisplayOtherInfo] = useState({
    joinDate: "",
    validity: "",
  });

  const [selectedMemberData, setSelectedMemberData] = useState({
    member_id: null,
    enrollment_start_date: null,
    enrollment_end_date: null,
    group_id: null,
    enrollment_id: null,
    date_of_birth: null,
  });

  const [selectedGroupId, setSelectedGroupId] = useState({
    programme_group_id: null,
  });

  const handleFromProgrammeChange = async (value) => {
    setFromProgramme(value);
    form.resetFields(["member_search"]);
    setMemberList([]);
    setMemberDisplayInfo({
      memberName: "",
      memberPrimaryMobile: "",
      memberFatherName: "",
      memberDOB: "",
      profilePic: "",
    });
    setMemberDisplayOtherInfo({
      joinDate: "",
      validity: "",
    });
    setSelectedMemberData({
      member_id: null,
      enrollment_start_date: null,
      enrollment_end_date: null,
      group_id: null,
      enrollment_id: null,
      date_of_birth: null,
    });
    setLastPaidData("");

    if (value === "JCP" || value === "HP" || value === "JHP") {
      const programme_id = value === "JCP" ? 3 : value === "JHP" ? 6 : 1;
      // console.log(object)

      try {
        const requestData = {
          formdata: {
            programme_id: programme_id,
            programme_group_id: 0,
            member_status: "Y",
          },
        };
        const response = await ProgrammeService.transferProgramme(requestData);

        if (response && response.data && response.data.response_data) {
          setMemberList(response.data.response_data);
        } else {
          console.error(
            "Response data is not in the expected format:",
            response
          );
          notification.error({
            message: "Error",
            description:
              "Unexpected response format. Please check the API response.",
          });
        }
      } catch (error) {
        console.error(
          "Error fetching member data:",
          error.response ? error.response.data : error.message
        );
        notification.error({
          message: "Error",
          description: "Error fetching member data. Please try again later.",
        });
      }
    }
  };

  const handleMemberSelect = (memberId) => {
   
    const selectedMember = memberList.find(
      (member) => member.member_id === memberId
    );
    if (selectedMember) {
      const dateOfBirth = moment(selectedMember.date_of_birth, "DD/MM/YYYY");
      const enrollmentEndDate = dateOfBirth
        .add(100, "years")
        .format("DD/MM/YYYY");

      form.setFieldsValue({
        member_name: `${selectedMember.member_fname} ${selectedMember.member_lname}`,
        member_primary_mobile: selectedMember.primary_mobile,
        member_father_name: selectedMember.father_name,
        date_of_birth: selectedMember.date_of_birth,
      });

      setMemberDisplayInfo({
        memberName: `${selectedMember.member_fname} ${selectedMember.member_lname}`,
        memberPrimaryMobile: selectedMember.primary_mobile,
        memberFatherName: selectedMember.father_name,
        memberDOB: selectedMember.date_of_birth,
        profilePic: selectedMember.profile_picture,
        old_enrollment_id: selectedMember.old_enrollment_id,
      });

      setMemberDisplayOtherInfo({
        joinDate: selectedMember.enrollment_date,
        validity: `${selectedMember.enrollment_start_date} to ${selectedMember.enrollment_end_date}`,
      });

      setSelectedMemberData({
        member_id: selectedMember.member_id,
        enrollment_start_date: selectedMember.enrollment_start_date,
        enrollment_end_date: selectedMember.enrollment_end_date,
        group_id: selectedMember.group_id,
        enrollment_id: selectedMember.enrollment_id,
        date_of_birth: selectedMember.date_of_birth,
      });

      setSelectedGroupId(selectedMember.programme_group_id);
      getLastPaidMonth(selectedMember.programme_id,selectedMember.enrollment_id)
    }
  };

  const onDateOfJoinChange = (date, dateString) => {
    form.setFieldsValue({
      date_of_join: dateString,
    });
  };

  const onFinish = async (values) => {
    setSaveLoaderEnable(true);
    const formattedValues = {
      ...values,
      join_date: values.join_date.toISOString(),
      last_played_month: values.last_played_month
        ? values.last_played_month.format("YYYY-MM")
        : null,
      day_slot: values.day_slot,
    };

    const lastPlayedMonthFormatted = formattedValues.last_played_month
      ? moment(formattedValues.last_played_month, "YYYY-MM").format(
          "YYYY-MM-01"
        )
      : null;
    const programme_id =
      fromProgramme === "JCP" ? 3 : fromProgramme === "JHP" ? 6 : 1;
    const new_programme_id =
      form.getFieldValue("toProgramme") === "JCP"
        ? 3
        : form.getFieldValue("toProgramme") === "JHP"
        ? 6
        : 1;
        console.log(commonUtility.getLoggedInUserInfo());
    const requestData = {
      formdata: {
        enrolled_from: "PROMOTED",
        member_search: values.member_search,
        old_enrollment_id: selectedMemberData.enrollment_id,
        member_id: selectedMemberData.member_id,
        // programme_id: fromProgramme === 'JCP' ? 1 : 3,
        programme_id: programme_id,
        new_programme_id: new_programme_id,
        join_date: formattedValues.join_date,
        date_of_join: values.date_of_join,
        enrollment_start_date: values.date_of_join,
        enrollment_end_date: selectedMemberData.enrollment_end_date,
        group_id: selectedGroupId,
        last_paid_month_picker: values.last_paid_month_picker,
        last_played_month: lastPlayedMonthFormatted,
        day_slot: formattedValues.day_slot,
        user_id: commonUtility.getLoggedInUserInfo()?.user_id,
        company_id: commonUtility.getLoggedInUserInfo()?.companyID,
        year_id: commonUtility.getLoggedInUserInfo()?.yearID,
      },
    };

    try {
      const response = await ProgrammeService.saveTransferProgramme(
        requestData
      );
      if (response.data.response_status === "SUCCESS") {
        notification.success({
          message: "Success",
          description: response.data.response_data.response_msg,
        });
        form.resetFields();
        setMemberDisplayInfo({
          memberName: "",
          memberPrimaryMobile: "",
          memberFatherName: "",
          memberDOB: "",
          profilePic: "",
        });
        setMemberDisplayOtherInfo({
          joinDate: "",
          validity: "",
        });
        setSelectedMemberData({
          member_id: null,
          enrollment_start_date: null,
          enrollment_end_date: null,
          group_id: null,
          enrollment_id: null,
          date_of_birth: null,
        });
        setTimeSlotList([]);
        setLastPaidData("");
      } else {
        // Extract the last_paid_date from response_data
        const lastPaidDateRaw = response.data.response_data[0]?.last_paid_date;
        const lastPaidDateFormatted = lastPaidDateRaw
          ? moment(lastPaidDateRaw).format("DD-MM-YYYY")
          : null;

        notification.error({
          message: "Error",
          description: (
            <div>
              {response.data.response_msg}
              {lastPaidDateFormatted && (
                <div>Last Paid Date: {lastPaidDateFormatted}</div>
              )}
            </div>
          ),
        });
      }
    } catch (error) {
      console.error("Error during API call:", error);
      notification.error({
        message: "Error",
        description:
          "There was an error processing your request. Please try again later.",
      });
    } finally {
      setSaveLoaderEnable(false);
      setIsModalVisible(false);
    }
  };

  const onTimeSlotChange = (selectedSlots) => {
    setTimeSlotList(selectedSlots);
    form.setFieldsValue({
      day_slot: selectedSlots.map((slot) => ({ day_id: slot.day_id })),
    });
  };

  const handleSaveButtonClick = () => {
    setIsModalVisible(true);
  };

  const onSelectProgrammeGroup = (value, event) => {
    console.log("groupValue", value);
    setProgrammeGroupID(value);
    setSelectedGroupId(value);
    form.setFieldsValue({ day_slot: [] });
  };

  useEffect(() => {
    ProgrammeService.programmeGroupList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeGroupList(res.data.response_data);
      }
    });
   
  }, []);

  const getLastPaidMonth = (programme_id,enrollment_id) => {
    const payload = {
        formdata: {
            fromProgrammeId: programme_id,
            enrollmentId: enrollment_id            
        }
    }
    ProgrammeService.getLastPaidMonth(payload).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
            // console.log("res.data.response_data",res.data.response_data);
            setLastPaidData(res.data.response_data)
   
        }
      });
  };


  return (
    <div className="form-input-style">
      <Row
        className="login-first-step-row"
        style={{ background: "transparent" }}
      >
        <Col
          className="form-format-type1 enrollment-form jcp-enrollment"
          xs={24}
          xl={24}
        >
          <Form
            form={form}
            layout="vertical"
            autoComplete="off"
            initialValues={defaultFormValues}
            onFinish={onFinish}
          >
            <Collapse
              bordered={false}
              defaultActiveKey={["programme_jcp", "schedule_jcp"]}
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel
                header={<h4>Programme</h4>}
                key="programme_jcp"
                className="mainPanel"
              >
                <Row gutter={20}>
                  <Col xs={24} xl={12}>
                    <Row gutter={20}>
                      <Col className="gutter-row" xs={24} xl={24}>
                        <Form.Item
                          label="From Programme"
                          name="fromProgramme"
                          rules={[
                            { required: true, message: "Select Programme" },
                          ]}
                        >
                          <Select
                            showSearch
                            placeholder="Select Programme"
                            onChange={handleFromProgrammeChange}
                          >
                            <Option value="JCP">JCP</Option>
                            <Option value="HP">HP</Option>
                            <Option value="JHP">JHP</Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col className="gutter-row" xs={24} xl={24}>
                        <Form.Item
                          name="member_search"
                          label="Search (Name | Mobile no | Father Name)"
                          rules={[
                            {
                              required: true,
                              message: "Select Member / Student",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            onSelect={handleMemberSelect}
                          >
                            {memberList.map((member) => (
                              <Option
                                key={member.member_id}
                                value={member.member_id}
                              >
                                {`${member.member_fname} ${
                                  member.member_lname
                                } | ${member.primary_mobile} ${
                                  member.father_name || ""
                                }`}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col className="gutter-row" xs={24} xl={24}>
                        <Form.Item
                          label="To Programme"
                          name="toProgramme"
                                                 
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  getFieldValue("fromProgramme") !== value
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error(
                                    "Cannot select the same Programme as From"
                                  )
                                );
                              },
                            }),
                          ]}
                        >
                          <Select showSearch placeholder="Select Programme"  onChange={setToProgramme}>
                            <Option
                              value="JCP"
                              disabled={fromProgramme === "JCP"}
                             
                            >
                              JCP
                            </Option>
                            <Option
                              value="HP"
                              disabled={fromProgramme === "HP"}
                            >
                              HP
                            </Option>
                            <Option
                              value="JHP"
                              disabled={fromProgramme === "JHP"}
                            >
                              JHP
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col className="gutter-row" xs={24} xl={12}>
                        <Form.Item
                          name="join_date"
                          label="Date of joining"
                          rules={[
                            {
                              required: true,
                              message: "Date of joining is required",
                            },
                          ]}
                        >
                          <DatePicker
                            format={DATE_FORMAT_DMY_SLASH}
                            onChange={onDateOfJoinChange}
                            style={{ width: "100%" }}
                            inputReadOnly={true}
                          />
                        </Form.Item>
                        <Form.Item name="date_of_join" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>

                      <Col className="gutter-row" xs={24} xl={12}>
                        <Form.Item
                          name="last_played_month"
                          label="Last Played Month"
                          rules={[
                            {
                              required: true,
                              message: "Last played month is required",
                            },
                          ]}
                        >
                          <DatePicker
                            format="YYYY-MM"
                            style={{ width: "100%" }}
                            inputReadOnly
                            picker="month"
                          />
                        </Form.Item>
                      </Col>
                      {toProgramme === "JCP" && (
                        <Col xs={24} xl={12}>
                          <Form.Item
                            name="group_id"
                            label="Shift"
                            rules={[
                              {
                                required: true,
                                message: "Group is required",
                              },
                            ]}
                          >
                            <Select
                              className="text-left"
                              onSelect={(value, event) =>
                                onSelectProgrammeGroup(value, event)
                              }
                              placeholder="Select Shift"
                            >
                              <Option value="">Select</Option>
                              {programmeGroupList.length > 0
                                ? programmeGroupList.map(
                                    (programme_group_list) => (
                                      <Option
                                        key={
                                          programme_group_list.programme_group_id
                                        }
                                        value={
                                          programme_group_list.programme_group_id
                                        }
                                      >
                                        {programme_group_list.programme_group}
                                      </Option>
                                    )
                                  )
                                : ""}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col xs={24} xl={12}>
                    <Row gutter={20} style={{ marginBottom: "10px" }}>
                      <Col xs={24} xl={24}>
                        <StudentCardInfo
                          memberDisplayInfo={memberDisplayInfo}
                          memberDisplayOtherInfo={memberDisplayOtherInfo}
                        />
                      </Col>
                    </Row>
                    {
                     lastPaidData ? <>
                    <Row gutter={20}>
                      <Col xs={24} xl={24}>
                        <Card
                          title=""
                          style={{
                            width: "auto",
                          }}
                          className="studentInfoCard"
                
                        >
                          <Row gutter={10}>
                            <Col
                              xs={24}
                              xl={12}
                              className="student-personal-info"
                              style={styles.studentPersonalInfo}
                            >
                              
                              <h2>Fees Paid Up To</h2>

                              <Space direction="vertical">
                                <Text>{`${lastPaidData.month_name} ${lastPaidData.year}`}</Text>
                              </Space>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                    </> :<></> }
                  </Col>
                </Row>
              </Panel>

              {(form.getFieldValue("mode") === "EDIT" ||
                form.getFieldValue("mode") === "ADD") && (
                <Panel
                  header={<h4>Schedule</h4>}
                  key="schedule_jcp"
                  className="mainPanel"
                >
                  <TimeSlotEnrollment
                    mode={form.getFieldValue("mode")}
                    timeSlotListData={timeSlotList}
                    key={commonUtility.randomID()}
                    isDayRequired={true}
                    isDayTimeRequired={false}
                    module={HIGH_PERFORMANCE_TAG}
                    form={form}
                    onTimeSlotChange={onTimeSlotChange}
                  />
                </Panel>
              )}
            </Collapse>

            <Row justify="end">
              <Col>
                <Form.Item>
                  {isSaveLoaderEnable ? (
                    <Spin />
                  ) : (
                    <Button
                      htmlType="button"
                      shape="round"
                      className="custom-button-green"
                      onClick={handleSaveButtonClick}
                    >
                      Save <RightOutlined />
                    </Button>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>

      <Modal
        title="Confirm Save"
        visible={isModalVisible}
        onOk={form.submit}
        onCancel={() => setIsModalVisible(false)}
        okText="Yes"
        cancelText="No"
        className="custom-modal"
      >
        <p>Do You Want To Save?</p>
      </Modal>
    </div>
  );
};

export default ProgramTransfer;
